2
<template>
  <div class="menber-dialog">
    <el-dialog title="诊断回复" :visible.sync="show" :before-close="handleClose" width="50%">
      <div class="form">
        <el-form ref="form" :model="form" label-width="100px" :rules="formRules">
          <el-form-item label="作物类型" prop="consultTitle">
            <el-input v-model="form.consultTitle" disabled></el-input>
          </el-form-item>
          <el-form-item label="问题描述" prop="consultDesc">
            <el-input v-model="form.consultDesc" disabled></el-input>
          </el-form-item>
          <el-form-item label="咨询附件:" class="fileUpStyle">
            <el-upload :disabled="true" ref="upload" class="upload-demo no-image" :limit="6"
              :file-list="consultFilesShow" action="" list-type="picture-card">
            </el-upload>
          </el-form-item>
          <el-form-item label="回复内容">
            <el-input :disabled="isTrue" v-model="form.replyDesc" type="textarea" :rows="4"></el-input>
          </el-form-item>
          <el-form-item v-if="fileListShow.length||!isTrue" label="回复附件:" class="fileUpStyle">
            <el-upload :disabled="isTrue" :class="isTrue?  'no-image upload-demo' :'upload-demo'" ref="upload" multiple class=""
              :limit="6" :on-remove="handleRemoveClick" action="" name="files" :on-change="handleChange"
              :auto-upload="false" :file-list="fileListShow" list-type="picture-card">
              <el-button type="primary">上传附件</el-button>
              <div v-if="!isTrue" slot="tip" class="el-upload__tip">
                单张图片最大6M，最多上传6张，支持：JPG/JPEG/GIF/PNG格式
              </div>
            </el-upload>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer" v-if="!isTrue">
        <el-button style="margin-top: 20px" @click="handleClose">取消</el-button>
        <el-button type="primary" @click="handleConfirm">{{isTrue?'确定' :'保存'}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import {
    uploadZXFile,
    replyConsult
  } from "@/api/supplyDemand";
  export default {
    data() {
      return {
        // 表单规则校验
        // formRules: {
        //   replyContent: [
        //     { required: true, message: "请输入回复内容", trigger: "change" },
        //   ],
        // },
        formRules: {

        },
        baseUrl: window.globalUrl.BASE_API,
        // 表单
        form: {
          consultTitle: '',//作物类型
          consultDesc: '',//问题描述
          isReply: '1',
          replyDesc: '',//回复内容
        },
        replyFileList: [],//回复附件用于上传
        consultFiles: [],//咨询附件
        consultFilesShow: [],//展示咨询附件
        show: true,
        fileList: [],//咨询附件
        // fileList2: [],//回复附件
        fileListShow: [],//展示回复附件
        id: '',//咨询id
        isTrue:false, //是否禁用输入框
      };
    },
    methods: {
      //回显提问的数据
      editObj(obj, isTure) {
        // console.log(isTure,'查看isTrue')
        // console.log(obj,'查看obj')
        //是否禁用输入框
        this.isTrue = isTure,
          this.form.consultTitle = obj.consultTitle
        this.form.consultDesc = obj.consultDesc
        this.consultFiles = obj.consultFiles ? obj.consultFiles : []
        this.consultFilesShow = this.changeFile(obj.consultFiles)
        this.fileListShow = this.changeFile(obj.replyFiles)
        this.replyFileList = obj.replyFiles ? obj.replyFiles : []
        this.form.replyDesc = obj.replyDesc
        // console.log(this.replyFileList, '查看replyFileList')
        this.id = obj.consultId
        // this.fileList2 = obj.replyFileList
        // console.log('查看obj', JSON.parse(JSON.stringify(obj)))
        // console.log(this.consultFilesShow, '查看this.consultFiles')
      },
      //改变changeFile格式
      changeFile(list) {
        if (!list) return;
        return list.map(file => {
          const url = this.baseUrl + "admin/file/get?ossFilePath=" + file.fileUrl;
          return {
            fileName: file.fileName,
            url: url,
            fileType: file.fileType,
            url2: file.fileUrl
          }
        })

      },

      // 取消
      handleClose() {
        this.$emit("closeDialog", false);
      },
      //请求上传文件
      handleChange(file, filelist) {
        this.uploadLoadFiles(file, filelist);
      },
      //上传远程诊断咨询文件接口
      async uploadLoadFiles(file, filelist) {
        var type = file.name.substring(file.name.lastIndexOf(".") + 1);
        var formData = new FormData();
        formData.append("files", 'recover');
        formData.append("file", file.raw);
        uploadZXFile(formData)
          .then((res) => {
            if (res && res.code == 0) {
              console.log('这里执行了吗')
              let name = this.getDataValue(res.data, 'sourceFileName');
              let url = this.getDataValue(res.data, 'url');
              let uid = file.uid;
              file.url2 = res.data.url;
              // this.fileList2.push({
              //   fileName: name,
              //   fileUrl: url,
              //   fileType: type,
              // });
              console.log(this.replyFileList, 'this.replyFileList')
              this.replyFileList.push({
                fileName: name,
                fileUrl: url,
                fileType: type,
              });
              console.log(this.replyFileList, '查看replyFileList')
              // console.log(this.fileList2, '查看fileList2')
            }
          })
      },
      //取值规则
      getDataValue(data, key) {
        if (Array.isArray(data) && data.length > 0) {
          return data[0][key] || data[0].originName;
        }
        return data[key] || data.originName;
      },
      //删除
      handleRemoveClick(file, fileList) {
        console.log(file, fileList, '查看数据');
        let sz = []
        this.loading = true; // 显示加载状态
        if (fileList.length) {
          fileList.forEach((item) => {
            sz.push({
              fileName: item.fileName,
              fileUrl: item.url2,
              fileType: item.fileType,
            });
          });
        } else {
          sz = []
        }
        console.log(sz, '查看sz')
        this.replyFileList = sz;


      },

      //保存
      async handleConfirm() {
        console.log(this.replyFileList, '查看resplayFileList')
        let params = {
          ...this.form,
          replyFileList: this.replyFileList,
          consultFiles: this.consultFiles,
          id: this.id
        }
        // console.log(JSON.parse(JSON.stringify(params)), '查看params')
        // 保存
        let res = await replyConsult(params)
        if (res.code == 0) {
          this.$message.success(res.msg);
          this.handleClose()
        } else {
          this.$message.error(res.msg);
        }
        // this.$refs.form.validate(async (valid) => {
        //   if (valid) {
        
        //     let res = await replyConsult(this.form)
        //   } else {
        //     this.$message.error("请完善发布信息");
        //   }
        // });
      },


    },
  };
</script>
<style lang="less" scoped>
  .no-image {
    /deep/.el-upload {
      display: none !important;
    }
  }
</style>
